import styled from 'styled-components'

type AspectRatioType = {
  children: any,
  ratio: any,
  backgroundSrc?: String
}

const AspectRatio = ({ children, ratio, backgroundSrc } : AspectRatioType) => {
  return (
    <S_AspectRatio ratio={`${100 / ratio}%`} src={backgroundSrc}>
      <S_Content>
        {
          children
        }
      </S_Content>
    </S_AspectRatio>
  )
}

export default AspectRatio

const S_AspectRatio = styled.div`
  width: 100%;
  padding-top: 56.25%;
  padding-top: ${props => props.ratio};
  height: 0;
  position: relative;
  overflow: hidden;
  background-image: url(${props => props.src});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`

const S_Content = styled.div`
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`